import React, { useState, useRef, useEffect } from 'react';

// Button that opens a small menu of actions — used for the Download and Share
// options on the document preview pages, so the toolbar stays two controls
// instead of one button per format.
export default function MenuButton({
  icon,
  label,
  items = [],
  disabled = false,
  variant = 'btn-dark',
  align = 'right',      // which edge of the button the menu lines up with
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  // Closing before the action runs keeps the menu from hanging around while a
  // PDF builds or the share sheet opens.
  const run = (fn) => { setOpen(false); fn(); };

  return (
    <div className="menu-btn" ref={wrapRef}>
      <button
        type="button"
        className={`btn ${variant}`}
        style={{ fontSize: '0.7rem' }}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}>
        {icon} {label} <span className="menu-btn-caret">▾</span>
      </button>
      {open && (
        <div className="menu-pop" role="menu" style={align === 'right' ? { right: 0 } : { left: 0 }}>
          {items.map(item => (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              className="menu-pop-item"
              onClick={() => run(item.onClick)}>
              {item.icon && <span className="menu-pop-icon">{item.icon}</span>}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
